export const pricing = {
	title: "PRICING",
	fields: {
		saleType: {
			label: "Sale type",
			placeholder: "Unit",
			options: {
				unit: "Unit",
				gram: "Grams",
				liter: "Liters",
				variable: "Variable Price",
			},
		},
		unitOfMeasure: {
			label: "Unit of measure",
			placeholder: "Gram",
			fixedUnit: "Unit (1)",
			options: {
				gramas: "Grams",
				ml: "Milliliters",
			},
		},
		quantity: {
			label: "Quantity",
			placeholder: "100",
		},
		price: {
			label: "Price",
			placeholder: "00.00",
			tooltip: "Optional price, you can define or change it at POS",
		},
	},
	variablePriceInfo: {
		title: "Price set at POS",
		description:
			"Variable price products have no fixed value. The price is entered at the POS at the time of sale.",
	},
};
